import { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import Captcha from "demos-react-captcha";
import Select from "react-select";
import InputMask from "react-input-mask";

import API from "../../../api/baseUrl";
import { serialize, original } from "../../../functions/helper";
import config from "../../../config.json";
import { enDate, faDate, customDayDate } from "../../../functions/date";
import FastVisitModal from "../../../components/modal/FastVisitModal";
import weekApi from "../../../api/week";
import Loading from "../../../components/loading";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Gap from "../../../components/gap";
import { paymentService } from "../../../api/payment";

const dateMask = {
	mask: "9999/99/99",
	maskChar: "_",
	alwaysShowMask: false,
	formatChars: {
		9: "[0-9]",
		a: "[A-Za-z]",
		"*": "[A-Za-z0-9]",
	},
	permanents: [2, 5],
};

export default function TicketPage() {
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [explains, setExplains] = useState([]);
	const [services, setServices] = useState([]);
	const [users, setUsers] = useState([]);

	const Login_User_Token = localStorage.getItem("user_login_token");
	const Login_User_cp = localStorage.getItem("user_login_cp");

	const ticketInfo = JSON.parse(localStorage.getItem("ticketInfo"));

	const { state } = useLocation();

	const [data, setData] = useState({
		phone: ticketInfo?.phone ? ticketInfo?.phone : "",
		tel: ticketInfo?.tel ? ticketInfo?.tel : "",
		email: ticketInfo?.email ? ticketInfo?.email : "",
		desc: "",
		service: { label: "", value: 0 },
		user: { label: "", value: 0 },
	});

	useEffect(() => {
		fetchData();
	}, []);

	const fetchData = async () => {
		try {
			setLoading(true);
			const [explainRes, serviceRes, usersRes] = await Promise.all([
				API.post(
					serialize({
						id: 4554,
						sp_param: `'${Login_User_Token}','${Login_User_cp}','1','1','1','1','1'`,
						Login_User_Token: localStorage.getItem("user_login_token"),
						Login_User_cp: localStorage.getItem("user_login_cp"),
					}),
				),
				API.post(
					serialize({
						id: 4556,
						sp_param: `'${Login_User_Token}','${Login_User_cp}','1','1','1','1','1'`,
						Login_User_Token: localStorage.getItem("user_login_token"),
						Login_User_cp: localStorage.getItem("user_login_cp"),
					}),
				),
				API.post(
					serialize({
						id: 4557,
						sp_param: `'${Login_User_Token}','${Login_User_cp}','1','1','1','1','1'`,
						Login_User_Token: localStorage.getItem("user_login_token"),
						Login_User_cp: localStorage.getItem("user_login_cp"),
					}),
				),
			]);

			let explainParse = original(explainRes.data, false);
			let serviceParse = original(serviceRes.data, false);
			let usersParse = original(usersRes.data, false);

			setExplains(explainParse);
			setServices(serviceParse);
			setUsers(usersParse);
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	const handleAlarm = async () => {
		try {
			setLoading(true);
			const res = await API.post(
				serialize({
					id: 4558,
					sp_param: `'${Login_User_Token}','${Login_User_cp}','1','1','1','1','1','0','1','${data.service?.value}','${data.user?.value}','${data.desc}','${data.phone}','${data.tel}','${data.email}','1'`,
					Login_User_Token: localStorage.getItem("user_login_token"),
					Login_User_cp: localStorage.getItem("user_login_cp"),
				}),
			);

			let resParse = original(res.data, false);

			if (resParse[0].s_result > "0") {
				handlePreventBefore();
			} else {
				swal({
					// title: "Are you sure?",
					text: `${resParse[0]?.s_message
						.split("\r")
						.map((item) => (item ? item + "\n" : ""))}`,
					icon: false,
					buttons: ["انصراف", "ادامه"],
				}).then((val) => {
					if (val) {
						handlePreventBefore();
					}
				});
			}
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	const handlePreventBefore = async () => {
		try {
			setLoading(true);
			const res = await API.post(
				serialize({
					id: 4559,
					sp_param: `'${Login_User_Token}','${Login_User_cp}','1','1','1','1','1','0','1','${data.service?.value}','${data.user?.value}','${data.desc}','${data.phone}','${data.tel}','${data.email}','1'`,
					Login_User_Token: localStorage.getItem("user_login_token"),
					Login_User_cp: localStorage.getItem("user_login_cp"),
				}),
			);

			let resParse = original(res.data, false);

			if (resParse[0].s_result > "0") {
				// swal({
				// 	// title: "Are you sure?",
				// 	text: `تیکت شما آماده ی ارسال لطفا تایید کنید`,
				// 	icon: false,
				// 	buttons: ["کنسل", "ارسال"],
				// }).then((val) => {
				// 	if (val) {
				// 	}
				// });
				handleSubmit();
			} else {
				swal({
					// title: "Are you sure?",
					text: `${resParse[0]?.s_message
						.split("\r")
						.map((item) => (item ? item + "\n" : ""))}`,
					icon: false,
					button: "متوجه شدم!",
				});
			}
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	const handleSubmit = async () => {
		try {
			setLoading(true);
			const res = await API.post(
				serialize({
					id: 4551,
					sp_param: `'${Login_User_Token}','${Login_User_cp}','1','1','1','1','1','0','1','${data.service?.value}','${data.user?.value}','${data.desc}','${data.phone}','${data.tel}','${data.email}','1'`,
					Login_User_Token: localStorage.getItem("user_login_token"),
					Login_User_cp: localStorage.getItem("user_login_cp"),
				}),
			);

			let resParse = original(res.data, false);

			if (resParse[0].s_result > "0") {
				localStorage.setItem(
					"ticketInfo",
					JSON.stringify({
						email: data.email,
						phone: data.phone,
						tel: data.tel,
					}),
				);

				swal({
					text: `${resParse[0]?.s_message
						.split("\r")
						.map((item) => (item ? item + "\n" : ""))}`,
					icon: "success",
					button: "تایید",
				});

				setData({
					phone: "",
					tel: "",
					email: "",
					desc: "",
				});
			} else {
				swal({
					text: `${resParse[0]?.s_message
						.split("\r")
						.map((item) => (item ? item + "\n" : ""))}`,
					icon: false,
					button: "متوجه شدم!",
				});
			}
			console.log(resParse);
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	};

	const handlePayment = () => {
		swal({
			content: {
			  element: "input",
			  attributes: {
				placeholder: "لطفا مبلغ را دارد کنید",
				type: "number",
			  },
			},
		  }).then((val) => {
			paymentService(
				"",
				"",
				val,
				"",
				"",
				"222",
				"",
			);
		  })
	};

	return (
		<div
			className="fast-visit-page"
			style={{
				background: `linear-gradient(45deg,${
					config.auth_back_color_1
						? config.auth_back_color_1
						: "rgba(86, 0, 110, 1)"
				} 10%,${
					config.auth_back_color_2
						? config.auth_back_color_2
						: "rgba(33, 150, 243, 1)"
				} 100%)`,
			}}
		>
			<div className="fast-visit-page__box">
				{/* <h1>{config.header ? config.header : "NeedSoft"}</h1> */}
				<h2 className="fast-visit-page__title">ثبت تیکت</h2>
				<div className="fast-visit-page__desc">
					{explains.map((item, index) => (
						<span key={index}>{item.line_value}</span>
					))}
				</div>
				<Gap size={20} />

				<form className="fast-visit-page__form">
					<div className="text-input">
						<Select
							options={services.map((item) => {
								return { label: item.ns, value: item.cs };
							})}
							value={data.service?.value ? data.service : null}
							isLoading={loading}
							onChange={(e) => {
								setData({
									...data,
									service: { label: e.label, value: e.value },
								});
							}}
							//   onInputChange={(e) => handleUserInputChange(e)}
							loadingMessage={() => "لطفا صبر کنید"}
							// onKeyDown={handleFindUser}
							placeholder={"انتخاب سرویس"}
							// isClearable={true}
						/>
					</div>
					<div className="text-input">
						<Select
							options={users.map((item) => {
								return { label: item.np, value: item.cp };
							})}
							value={data.user?.value ? data.user : null}
							isLoading={loading}
							onChange={(e) => {
								setData({
									...data,
									user: { label: e.label, value: e.value },
								});
							}}
							//   onInputChange={(e) => handleUserInputChange(e)}
							loadingMessage={() => "لطفا صبر کنید"}
							// onKeyDown={handleFindUser}
							placeholder={"انتخاب کاربر"}
							// isClearable={true}
						/>
					</div>

					<div className="text-input" style={{ width: "100%" }}>
						<textarea
							value={data.desc}
							style={{ width: "98%" }}
							className="text-input__textarea"
							onChange={(e) => setData({ ...data, desc: e.target.value })}
							placeholder={"متن تیکت"}
						></textarea>
					</div>

					

					<div className="text-input">
						<input
							type="text"
							id="text"
							className="text-input__input ltr"
							value={data.phone}
							placeholder={"تلفن همراه"}
							onChange={(e) =>
								setData({
									...data,
									phone: e.target.value,
								})
							}
						/>
					</div>

					<div className="text-input">
						<input
							type="text"
							id="text"
							className="text-input__input ltr"
							value={data.tel}
							placeholder={"تلفن ثابت"}
							onChange={(e) =>
								setData({
									...data,
									tel: e.target.value,
								})
							}
						/>
					</div>

					<div className="text-input">
						<input
							type="text"
							id="email"
							className="text-input__input ltr"
							value={data.email}
							placeholder={"ایمیل"}
							onChange={(e) =>
								setData({
									...data,
									email: e.target.value,
								})
							}
						/>
					</div>

					<div style={{width: "100%"}}>
						<label style={{color: "#fff"}}>پیوست مستندات</label>
						<br />
						<input type="file"/>
						<Gap size={15}/>
					</div>

					<div className="button-container">
						<button
							type="button"
							className="fast-visit-page__form_btn"
							onClick={handleAlarm}
						>
							ثبت تیکت
						</button>

						{/* )} */}
					</div>
					<div className="fast-visit-page__form_links">
						<Link to={{ pathname: "/" }}>صفحه اصلی</Link>
						<Link to={{ pathname: "/ticket/list" }}>لیست تیکت ها</Link>
						<Link onClick={handlePayment}>پرداخت</Link>
					</div>
				</form>
				<div className="fast-visit-page__box_footer">
					<span>{enDate}</span>
				</div>
			</div>
			{loading && <Loading />}
		</div>
	);
}
